<div class="row">
  <div class="col-md-4 col-lg-4 mt-10 benefitCard" *ngFor="let benefitCard of benefitCards">
    <div class="image-title-card">
      <div class="card lift">
        <div class="image-tile-container">
          <div class="inner-container">
            <div class="card-image-header show-image" style="background-image: url('{{ benefitCard.headImage }}');">&nbsp;</div>
          </div>
        </div>
        <div class="card-body min-80">
          <i class="{{ benefitCard.headIconClass }}"></i>
          <h5>{{ benefitCard.title }}</h5>
          <p>{{ benefitCard.body }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
